/**
 * Format a count with a singular/plural noun as a single string.
 * Prefer this over adjacent JSX text nodes (`noun{n !== 1 ? "s" : ""}`),
 * which can read as "noun s" to assistive tech and invite always-plural bugs.
 */
export function pluralize(
  count: number,
  singular: string,
  plural: string = `${singular}s`,
): string {
  const n = Number.isFinite(count) ? count : 0;
  return `${n} ${n === 1 ? singular : plural}`;
}
